import { useEffect, useRef, useState } from 'react';
import Tooltip from '@shared/ui/Tooltip/Tooltip';

// The shared hint card (see Tooltip), widened to the content: a cell's
// full text, which may hold several chips side by side.
const FIT_CONTENT = { tooltip: { sx: { maxWidth: 'fit-content' } } };

function OverflownText({ data }) {
  const ref = useRef(null);
  const [isOverflown, setIsOverflown] = useState(true);

  useEffect(() => {
    const element = ref.current;
    setIsOverflown(element.firstChild.scrollWidth > element.clientWidth);
  }, [ref.current]);

  return (
    <Tooltip
      slotProps={FIT_CONTENT}
      disableFocusListener={!isOverflown}
      disableHoverListener={!isOverflown}
      disableTouchListener={!isOverflown}
      placement={'top'}
      title={
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 5,
            flexDirection: 'column',
          }}
        >
          {data}
        </div>
      }
    >
      <div
        ref={ref}
        style={{
          maxWidth: '100%',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          WebkitMaskImage: isOverflown ? 'linear-gradient(90deg, #000 70%, transparent)' : 'none',
        }}
      >
        <div
          style={{
            whiteSpace: 'nowrap',
            display: 'flex',
            height: '100%',
            width: 'fit-content',
            backgroundColor: 'transparent',
            transition: 'background-color .3s ease-in, font-weight .3s ease-in',
            overflow: 'hidden',
            gap: 5,
            alignItems: 'center',
          }}
        >
          {data}
        </div>
      </div>
    </Tooltip>
  );
}

export default OverflownText;
